import { REQUEST_ORIGINS } from '@frontend/person-invoice-create';
import { CollectPaymentMultiModalInstance } from '../collect-payment-multi';
import { UsePaymentsModalButtonReturnType } from '../hooks';

type PaymentRequestModalProps = UsePaymentsModalButtonReturnType['paymentRequestModalProps'] & {
  onInvoiceCreated?: (invoiceId: string) => void;
  origin?: REQUEST_ORIGINS;
};

export const PaymentRequestModal = ({ Tooltip, onInvoiceCreated, origin, ...rest }: PaymentRequestModalProps) => {
  return (
    <>
      <CollectPaymentMultiModalInstance
        modalProps={rest}
        collectProps={{
          flow: 'create',
          origin,
          onInvoiceCreated,
        }}
      />
      {Tooltip}
    </>
  );
};
